import { Component } from '@angular/core';

@Component({
  selector: 'app-sidebar-form',
  templateUrl: './app-sidebar-form.component.html'
})
export class AppSidebarFormComponent { }



// WEBPACK FOOTER //
// /var/www/midac/midac-live/app/src/app/components/app-sidebar-form/app-sidebar-form.component.ts